var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useTranslation } from "react-i18next";
export var InfoBar = function (_a) {
    var elements = _a.elements;
    var t = useTranslation(['advanced-search']).t;
    return (_jsx(React.Fragment, { children: _jsx("div", __assign({ className: "under-filter-info" }, { children: _jsxs("div", { children: [" ", elements, " ", t("éléments")] }) })) }));
};
